import { BaseMapScene } from "./BaseMapScene.js";

export class MapCombat01Scene extends BaseMapScene {
  constructor() {
    super("MapCombat01Scene", "map_combat_01");
  }
}
